import { Navbar, Footer } from "@/components/site/Navbar";

const PAGES = {
  privacy: {
    title: "Privacy policy",
    body: [
      "SuperDeals.world collects only the information needed to run the marketplace: your name, email, optional mobile number, and the coupons you claim and redeem.",
      "Your precise GPS location is used only in your browser to find nearby deals. We do not store your GPS history. If you save a preferred location, it is rounded to roughly 100 metres.",
      "Merchants never see your email, phone number or location. At redemption they see only your first name and last initial.",
      "You can request deletion of your account and personal data by contacting our support team.",
    ],
  },
  terms: {
    title: "Terms of use",
    body: [
      "Deals are offered by independent merchants, who are responsible for honouring their offers and terms.",
      "Each coupon is valid for up to 24 hours from claiming, or until the deal expires, whichever is earlier. Coupons are single-use and non-transferable.",
      "Merchants are billed by simultaneous active deal slots. Subscription activation is handled manually by SuperDeals.world during launch.",
      "Fraudulent claims or redemptions may be cancelled and accounts suspended.",
    ],
  },
  contact: { title: "Contact us", body: ["Email: cs@superdeals.world", "Merchants: register at /seller/register and our team will contact you for activation."] },
};

export default function StaticPage({ page }) {
  const p = PAGES[page];
  return (
    <div className="bg-white min-h-screen">
      <Navbar />
      <article className="max-w-3xl mx-auto px-4 py-14 space-y-4" data-testid={`static-${page}`}>
        <h1 className="font-heading text-4xl font-extrabold tracking-tight text-slate-900">{p.title}</h1>
        {p.body.map((t, i) => <p key={i} className="text-slate-600 leading-relaxed">{t}</p>)}
      </article>
      <Footer />
    </div>
  );
}
